export default __webpack_public_path__ + "578f8829bb9278a1e6e374b2fedefda0.png";